// intro (compact versions only)
export const PERSONAL_LIBRARY_INTRO_CARD = 'personal-library-intro-card';
export const SHARED_LIBRARY_INTRO_CARD = 'shared-library-intro-card';
export const TEAM_LIBRARY_INTRO_CARD = 'team-library-intro-card';

// collaborate
export const ADD_COLLABORATOR_CARD_KEY = 'add-collaborator-card';
export const ADD_VIDEO_TO_TEAM_CARD_KEY = 'add-video-to-team-card';
export const EXPLORE_TEAM_LIBRARY_CARD_KEY = 'explore-team-library-card';

// features
export const CUSTOMIZE_BRANDING_CARD_KEY = 'customize-branding-card';

// how to use
export const RECORD_VIDEO_CARD_KEY = 'record-video-card';
export const SHARE_VIDEO_CARD_KEY = 'share-video-card';
export const UPLOAD_VIDEO_CARD_KEY = 'upload-video-card';

// organize
export const ORGANIZE_FOLDERS_CARD_KEY = 'organize-folders-card';

// tools
export const INSTALL_CHROME_EXTENSION_CARD_KEY = 'install-chrome-extension';
export const INSTALL_DESKTOP_APP_CARD_KEY = 'install-desktop-app';
export const INSTALL_IOS_APP_CARD_KEY = 'install-ios-app';

// non card related onboarding element keys
export const WORKSPACE_COMPACT_ONBOARDING_BANNER_STATE =
  'workspace-compact-onboarding-banner-state';
export const WORKSPACE_WELCOME_MODAL = 'workspace-welcome-modal';
export const WORKSPACE_AUTO_DOWNGRADED_SCREEN =
  'workspace-auto-downgraded-screen';
export const WORKSPACE_VIEWER_WELCOME_BANNER =
  'workspace-viewer-welcome-banner';
export const WORKSPACE_VIEWER_STAR_BUTTON_TOOLTIP =
  'workspace-viewer-star-button-tooltip';
export const WORKSPACE_DEFAULT_CHANGED_BANNER =
  'workspace-default-changed-banner';
export const WORKSPACE_DEFAULT_CHANGED_MODAL =
  'workspace-default-changed-modal';
// all onboarding cards
export const ALL_WORKSPACE_ONBOARDING_CARDS = [
  ADD_COLLABORATOR_CARD_KEY,
  ADD_VIDEO_TO_TEAM_CARD_KEY,
  EXPLORE_TEAM_LIBRARY_CARD_KEY,
  CUSTOMIZE_BRANDING_CARD_KEY,
  RECORD_VIDEO_CARD_KEY,
  SHARE_VIDEO_CARD_KEY,
  UPLOAD_VIDEO_CARD_KEY,
  ORGANIZE_FOLDERS_CARD_KEY,
  INSTALL_CHROME_EXTENSION_CARD_KEY,
  INSTALL_DESKTOP_APP_CARD_KEY,
  INSTALL_IOS_APP_CARD_KEY,
];

export const NEW_USER_ONLY_CARDS = new Set([
  INSTALL_CHROME_EXTENSION_CARD_KEY,
  INSTALL_DESKTOP_APP_CARD_KEY,
]);

// workspace onboarding element state
export const WORKSPACE_ELEMENT_SHOWN = 'element-shown';
export const WORKSPACE_ELEMENT_DISMISSED = 'element-dismissed';
export const WORKSPACE_ELEMENT_COMPLETE = 'element-complete';
